<template>
  <div
    class="service-card group relative p-8 rounded-2xl bg-white dark:bg-dark-surface border border-gray-200 dark:border-dark-border transition-all duration-300 hover:shadow-2xl hover:shadow-primary/10 dark:hover:shadow-accent/10 cursor-pointer hover:-translate-y-2 hover:scale-[1.02]"
  >
    <!-- Icon Container -->
    <div
      class="icon-wrapper mb-6 w-16 h-16 rounded-full bg-primary/10 dark:bg-accent/10 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-6"
    >
      <component :is="icon" class="w-8 h-8 text-primary dark:text-accent" />
    </div>

    <!-- Content -->
    <h3 class="text-2xl font-bold mb-4 text-gray-900 dark:text-white font-display">
      {{ title }}
    </h3>

    <p class="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
      {{ description }}
    </p>

    <!-- Features -->
    <ul class="space-y-3">
      <li
        v-for="(feature, index) in features"
        :key="index"
        class="flex items-center text-sm text-gray-600 dark:text-gray-400"
      >
        <Check class="w-5 h-5 mr-3 text-accent flex-shrink-0" />
        <span>{{ feature }}</span>
      </li>
    </ul>

    <!-- Hover Glow Effect -->
    <div class="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/0 to-accent/0 group-hover:from-primary/5 group-hover:to-accent/5 transition-all duration-300 pointer-events-none"></div>

    <!-- Corner Accent -->
    <div class="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-accent/20 to-transparent rounded-tr-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
  </div>
</template>

<script setup>
import { Check } from 'lucide-vue-next';

defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  icon: {
    type: Object,
    required: true
  },
  features: {
    type: Array,
    default: () => []
  }
});
</script>

<style scoped>
.service-card {
  will-change: transform;
}
</style>
